const o=(o,t)=>{const n=void 0!==o;return[n,n?o:t]};export{o as useControllableProp};
//# sourceMappingURL=useControllable.js.map
